// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d4b9db08","455":"22c9a2fe","977":"7df729f4"}[chunkId] + ".chunk.js";
};